import { render } from "./ColumnChart.vue?vue&type=template&id=36128428&scoped=true"
import script from "./ColumnChart.vue?vue&type=script&lang=js"
export * from "./ColumnChart.vue?vue&type=script&lang=js"

import "./ColumnChart.vue?vue&type=style&index=0&id=36128428&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36128428"]])

export default __exports__